import { action, createRequestTypes } from '@/utils/actions.utils'
import { collectionsService } from '@/services'

export const FETCH_COLLECTIONS = createRequestTypes('FETCH_COLLECTIONS')
const fetchCollections = ({ catalogId, lang, withImages = true, rolId = "" }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await collectionsService.fetchCollections({ catalogId, lang, withImages, rolId })

			return dispatch(success(res.data))

		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_COLLECTIONS.REQUEST)
	}
	function success(payload) {
		return action(FETCH_COLLECTIONS.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_COLLECTIONS.FAILURE, null, err)
	}
}

export const GET_COLLECTION = createRequestTypes('GET_COLLECTION')
const getCollection = ({ catalogId, lang, subFamilyId, withImages = true }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await collectionsService.fetchCollections({ catalogId, lang, subFamilyId, withImages })

			return dispatch(success(res.data[0]))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_COLLECTION.REQUEST)
	}
	function success(payload) {
		return action(GET_COLLECTION.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_COLLECTION.FAILURE, null, err)
	}
}

export const SELECT_COLLECTION = 'SELECT_COLLECTION'
const selectCollection = (collection) => {
	return action(SELECT_COLLECTION, collection)
}

export const UNSELECT_COLLECTION = 'UNSELECT_COLLECTION'
const unselectCollection = () => {
	return action(UNSELECT_COLLECTION)
}

export default {
	fetchCollections,
	getCollection,
	selectCollection,
	unselectCollection
}
